import React, { useMemo, MouseEvent, useState } from 'react';
import Checkbox from '../../../../../general-ui/checkbox/checkbox';
import Icon, { COLORS, ICONS } from '../../../../../general-ui/icon';
import { FeatureFlagsEnum, Product, VisibleProduct } from '../../../../../../types/working-model';
import ModalComponent from '../../../../../general-ui/modal/modal';
import { useTypedSelector } from '../../../../../../store/reducers/use-typed-selector';

interface Props {
	product: VisibleProduct;
	onClick: (product: VisibleProduct, isOn: boolean) => void;
	selected: any[];
	editProduct: (product: VisibleProduct) => void;
	replacing?: Product | boolean | null;
	deleteProduct: (product: VisibleProduct) => void;
}

export default function AddProduct(props: Props): JSX.Element {
	const {
		product,
		selected,
		onClick,
		editProduct,
		replacing = false,
		deleteProduct
	} = props;

	const replacingThisProduct = (replacing as Product)?.product === product.product;
	const featureFlags = useTypedSelector(state => state.FeatureFlagsReducer.featureFlags);
	const useEventHierarchy = featureFlags[FeatureFlagsEnum.event_hierarchy];

	const [isDeleting, setIsDeleting] = useState(false);
	const closeDeleteModal = () => setIsDeleting(false);

	function handleChange(e: any, isOn: boolean) {
		onClick(product, isOn);
	}

	const isSelected = useMemo(() => {
		return selected.includes(product.product);
	}, [selected, product.product]);

	function handleEdit(e: MouseEvent) {
		e.stopPropagation();
		editProduct(product);
	}

	function handleDelete(e: MouseEvent) {
		e.stopPropagation();
		if (!replacing) {
			setIsDeleting(true);
		}
	}

	function confirmDelete() {
		deleteProduct(product);
		closeDeleteModal();
	}

	return (
		<div className="add-product">
			<div
				className={`image-container ${replacing && replacingThisProduct && 'highlight-product'} ${!replacing && isSelected && 'highlight-product'}`}
				style={{ backgroundImage: `url(${product.images[0]?.replace(/\s/g, '%20')})` }}
				onClick={() => handleChange(product.product_title, replacing ? !replacingThisProduct : !isSelected)}
			>
				<div className="product-controls" >
					<Checkbox
						checked={replacing ? replacingThisProduct : isSelected}
						onChange={handleChange}
						value={product.product_title.base}
						size={20}
						color={isSelected ? COLORS.CYAN : COLORS.WHITE}
						backgroundColor={isSelected ? COLORS.WHITE : undefined}
						selectedIconName={replacingThisProduct ? ICONS.ON : ICONS.CHECKBOX_BORDERLESS}
						unselectedIconName={replacing ? ICONS.OFF : undefined}
					/>
					{!useEventHierarchy && !replacing &&
						(
							<div className="actions">
								<button onClick={handleEdit} className="no-style options"><Icon name={ICONS.EDIT} size={20} color={COLORS.WHITE} /></button>
								<button className="no-style" onClick={handleDelete}><Icon name={ICONS.TRASH} size={20} color={COLORS.WHITE} /></button>
							</div>
						)
					}
				</div>
			</div>
			<h6>{product.product_title.base}</h6>
			<p>{product.categories?.[0] ?? "Uncategorized"}</p>
			<ModalComponent
				title=""
				open={isDeleting}
				onRequestClose={closeDeleteModal}
				closeable={false}
				cancellable
				footer={
					<div className="delete-modal-buttons">
						<button onClick={closeDeleteModal}>Cancel</button>
						<button onClick={confirmDelete} className="primary">Delete</button>
					</div>
				}
			>
				<p>Are you sure you want to delete this product?</p>
			</ModalComponent>
		</div>
	);
}

